import * as React from 'react'

import {
  Box,
  Chevron,
  Icon,
  Text,
  Tooltip,
  Touchable,
  useToggle,
} from '@factorialco/deprecated-design-system'

interface ItemsCategoryProps {
  label: string
}

const UPDATED_DATA = 'updated data'

const ItemsCategory = ({ label, children }: React.PropsWithChildren<ItemsCategoryProps>) => {
  const [open, toggle] = useToggle(false)
  const [openInfo, toggleInfo] = useToggle(false)

  const direction = open ? 'up' : 'down'

  const showTooltip = label === UPDATED_DATA
  return (
    <>
      <Touchable onClick={toggle(!open)}>
        <Box
          paddingY="s8"
          paddingX="s16"
          background="grey000White"
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          flexGrow
        >
          <Text size="300" color="grey800" weight="medium">
            {label}
          </Text>
          {showTooltip && (
            <Tooltip.Alt
              toggle={toggleInfo}
              open={openInfo}
              attachment="middle left"
              label="Updates have a table format, therefore they are placed in a new line in the message body"
            >
              <Icon.Small icon="info" encircled="grey800" />
            </Tooltip.Alt>
          )}
          <Box>
            <Chevron type="terciary" direction={direction} />
          </Box>
        </Box>
      </Touchable>
      {open && <Box gap="s2">{children}</Box>}
    </>
  )
}

export default ItemsCategory
